import React from "react";
import "./LeftMenu.scss";
import MenuBuscaTermo from "./MenuBuscaTermo";
import MenuNavegacao from "./MenuNavegacao";
import MenuAlertas from "./MenuAlertas";
import MenuMinhaConta from "./MenuMinhaConta";
import MenuMinhaContaPlanos from "./MenuMinhaContaPlanos";
import MenuSuporte from "./MenuSuporte";
// import MenuConsultaProcessual from "./MenuConsultaProcessual";

// @TODO: move to containers
function LeftMenu({
  tipo,
  currentPlano,
  hasSubscriptionInMobileApp,
  isBlackFriday = false,
}) {
  switch (tipo) {
    case "navegacao":
      return <MenuNavegacao />;
    case "busca-termo":
      return <MenuBuscaTermo />;
    // case "consulta-processual":
    //   return <MenuConsultaProcessual />;
    case "alertas":
      return <MenuAlertas />;
    case "minha-conta":
      return <MenuMinhaConta />;
    case "minha-conta-planos":
      return (
        <MenuMinhaContaPlanos
          currentPlano={currentPlano}
          hasSubscriptionInMobileApp={hasSubscriptionInMobileApp}
          isBlackFriday={isBlackFriday}
        />
      );
    case "suporte":
      return <MenuSuporte />;
    default:
      return <span>No menu</span>;
  }
}

export default LeftMenu;
